export const gaEvent = (...args) =>
  (typeof window?.['gaEvent'] === 'function') && window['gaEvent'](...args)

export const ga = (...args) =>
  (typeof window?.['ga'] === 'function') && window['ga'](...args)
